(ns quuppa.ui.alert-popover
  (:require [clojure.string :as str]
            [quuppa.ui.modal :as modal]
            [reagent.core :as r]))

(defn alert-popover [{:keys [alerts title on-close! action]}]
  (let [open? (r/atom false)]
    (fn [{:keys [alerts title on-close! action]}]
      (let []
        (when (seq alerts)
          [:<>
           [:button.btn.btn-lg.btn-warning.mb-3
            {:on-click #(swap! open? not)}
            (count alerts) title]
           [modal/modal
            {:on-hide #(reset! open? false)
             :show @open?}
            [modal/header {:close-button true}
             [modal/title (str (count alerts) title)]]
            [modal/body
             (for [{:keys [heading body] :as alert} alerts]
               [:div.alert.alert-warning.text-break
                {:key heading}
                [:div.d-flex.flex-row
                 [:h4.flex-grow-1 heading]
                 (when (> (count alerts) 1)
                   [:button.btn.btn-link
                    {:on-click #(on-close! (:id alert))}
                    "×"])]
                [:p (some-> body
                            (str/replace #"</?[^>]+>" " ")
                            (str/replace #"\s+" " ")
                            str/trim)]
                (when action
                  action)])]]])))))
